// The stage schedule's API (card 524449bc). The organizer panel's api.js stays
// GET-only by design; the schedule is the one thing organizers edit (Devin
// 2026-10-07), so its write lives here.
import { serviceConsumer } from '../../../network/ServiceConsumer';

const BASE = () => `${process.env.REACT_APP_BASE_URL}/oireachtas`;

export const getSchedule = (id) => serviceConsumer('GET', `${BASE()}/${id}/schedule`);
export const saveSchedule = (id, body) => serviceConsumer('PUT', `${BASE()}/${id}/schedule`, body);

// serviceConsumer folds the HTTP status into its error; a 409 is "someone else
// saved since you loaded".
export const isConflict = (err) => err?.error?.response?.status === 409 || err?.statuscode === 409;

// Stage tablets are added and managed on Event Devices only (Devin
// 2026-10-25), in Organizer/JobDevices.
